import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcInfoIcon, IcSCopyIcon } from '@gem/icons';
import { IUserMentionData } from '@gem/models/commonModel';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import { ProfileSeeMoreDescription } from 'APP/main/Profile/components/ProfileSeeMoreDescription/ProfileSeeMoreDescription';

import { MetaBlock } from '../MetaBlock/MetaBlock';
import { useDescriptionPresenter } from './ProfileDescription.presenter';

interface IProfileDescriptionProps {
  className?: string;
  description: string;
  mentions?: IUserMentionData[];
  groupId?: string;
}

export const ProfileDescription: FC<IProfileDescriptionProps> = observer(
  ({ className, description, mentions, groupId }) => {
    const { t } = useTranslation();
    const { copyToClipboard, handleCopyToClipboard } = useDescriptionPresenter(description);

    return (
      <MetaBlock
        className={className}
        label={t('about_group_chat_block_title')}
        Icon={IcInfoIcon}
        Actions={
          <IconButton
            Icon={IcSCopyIcon}
            onClick={copyToClipboard}
          />
        }
      >
        <div
          role="button"
          tabIndex={0}
          data-test="profile-description"
          onClick={handleCopyToClipboard}
        >
          <ProfileSeeMoreDescription
            description={description}
            mentions={mentions}
            groupId={groupId}
          />
        </div>
      </MetaBlock>
    );
  }
);
